import { createApp } from 'vue'
import { createPinia } from 'pinia'
import naive from 'naive-ui'
import { installNaiveA11y } from '@architeia/naive-a11y'
import App from './App.vue'
import router from './router'
import { i18n } from './i18n'
import { captureDeletionConfirmationFragment } from './utils/deletion-confirmation'
import '@fontsource-variable/public-sans'
import '../../../libs/design-tokens/kora.css'
import './style.css'
import { getRuntimeConfig } from '@architeia/config'

// AINFRA-171: stop here, with a visible error, when /config.js is missing or invalid.
getRuntimeConfig()

// KORA-125: the emailed deletion link keeps its secret in the URL fragment; move it out of the
// address bar before anything else (auth initialization, a sign-in redirect) can see it.
captureDeletionConfirmationFragment()

const app = createApp(App)

// Pinia for state management
const pinia = createPinia()
app.use(pinia)

// vue-i18n (ADR-010)
app.use(i18n)

// Naive UI
app.use(naive)

// Router
app.use(router)

app.mount('#app')

// KORA-156: fill Naive UI's accessibility gaps (form labels, select roles, keyboard access to the
// menu, pagination and checkable tags, card heading levels, announced toasts).
installNaiveA11y()
